module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_plan_included_01-8f3b77f949cfe5a20ab753fd38ab1062.png";